/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { useShallow } from 'zustand/shallow';
import { TCustomerModuleModalRootTypes, useCustomerModuleModalRootStore } from './customer-modal-root.store';
import CreateLabelCustomerModal from '../../../label-customer/components/modals/create-label-customer-modal';
import UpdateLabelCustomerModal from '../../../label-customer/components/modals/update-label-customer-modal';
import DeleteLabelCustomerModal from '../../../label-customer/components/modals/delete-label-customer-modal';
import AssignLabelCustomerModal from '../../../label-customer/components/modals/assign-label-customer-modal';
import UpdateDetailCustomerModal from '../../../customer/components/modals/update-detail-customer-modal';
import CSATPreviewModal from '../../../customer-survey/components/modals/csat-preview-modal';
import DeleteQuestionListModal from '../../../customer-survey/components/modals/delete-question-list';
import CSATResponseDetailModal from '../../../customer-survey/components/modals/csat-response-detail-modal';

const modalMap: Partial<Record<TCustomerModuleModalRootTypes, React.ComponentType<any>>> = {
  // Label Customer Modal
  CreateLabelCustomerModal,
  UpdateLabelCustomerModal,
  DeleteLabelCustomerModal,
  AssignLabelCustomerModal,
  // Customer Detail Modal
  UpdateDetailCustomerModal,
  // CSAT Preview Modal
  CSATPreviewModal,
  // Delete Question List Modal
  DeleteQuestionListModal,
  // CSAT Response Detail Modal
  CSATResponseDetailModal,
};

// Memoize valid types to avoid recreating on every render
const validCustomerModalTypes = Object.keys(modalMap) as TCustomerModuleModalRootTypes[];

const CustomerModuleModalRoot = memo(() => {
  // Optimized: Only subscribe to modals that belong to this root
  // This prevents re-renders when other modal roots change
  const modals = useCustomerModuleModalRootStore(
    useShallow((state) => state.modals.filter((modal) => validCustomerModalTypes.includes(modal.type)))
  );

  // RENDER
  return (
    <>
      {modals.map(({ type, props }, idx) => {
        const ModalComponent = modalMap[type];
        const key = `${type}-${idx + 1}`;

        if (!ModalComponent) return null;

        return <ModalComponent key={key} {...props} />;
      })}
    </>
  );
});
CustomerModuleModalRoot.displayName = 'CustomerModuleModalRoot';
export default CustomerModuleModalRoot;
